<div class="login-wrapper">
  <div style="display: flex; align-items: center; justify-content: center">
    <div class="logo-container">
      <img src="assets/logo-login.svg" alt="" height="120px" width="120px" />
    </div>
  </div>
  <span class="login-title">Satsang Registration</span>

  <div class="login-card securityform-container">
    @if(securityStep===1){
    <span class="securityform-heading">
      Please provide following information to verify and register.
    </span>
    } @if (securityStep === 2) {
    <span class="securityform-heading">
      From your Arghya Praswasti, please provide the following details to help us verify your
      identity. </span
    >} @if (securityStep === 3) {
    <span class="securityform-heading">
      From your Arghya Praswasti or Dikshya Patra, please provide <b>any one</b> of the following
      details for verification.</span
    >}

    <div class="progressbar">
      <div class="step" *ngFor="let step of [1, 2, 3]" [class.active]="securityStep >= step"></div>
    </div>

    <form [formGroup]="securityForm" class="securityform-form">
      @if(securityStep === 1){
      <div class="form-group">
        <label for="contactSec">Enter your contact number *</label>
        <input
          id="contactSec"
          type="text"
          formControlName="contactNo"
          placeholder="Enter contact number"
          (keypress)="restrictFCInput($event)"
          maxlength="10"
        />
        @if(securityForm.get('contactNo')?.touched && securityForm.get('contactNo')?.invalid){
        @if(securityForm.get('contactNo')?.errors?.['required']){
        <small class="error-text">Please enter contact number</small>
        } @if(securityForm.get('contactNo')?.errors?.['minlength']){
        <small class="error-text">Please enter a valid contact number</small>
        } }
      </div>
      <div class="form-group">
        <label for="familyCodeSec">Enter your Family Code *</label>
        <input
          id="familyCodeSec"
          type="text"
          formControlName="fcSecurityForm"
          placeholder="Enter 12 digit family code"
          (keypress)="restrictFCInput($event)"
          maxlength="12"
        />
        @if(securityForm.get('fcSecurityForm')?.touched &&
        securityForm.get('fcSecurityForm')?.invalid){
        @if(securityForm.get('fcSecurityForm')?.errors?.['required']){
        <small class="error-text">Please enter FC number</small>
        } @if(securityForm.get('fcSecurityForm')?.errors?.['minlength']){
        <small class="error-text">Please enter a valid FC number</small>
        } }
      </div>

      <div class="form-group">
        <label for="nameAsPerAP">Enter your Name as per Arghya Praswasti * (include middle name & spaces exactly as on your Arghya Praswasti)</label>
        <input
          id="nameAsPerAP"
          type="text"
          formControlName="nameAsPerAP"
          placeholder="Enter Name"
        />
        @if(securityForm.get('nameAsPerAP')?.touched &&
        securityForm.get('nameAsPerAP')?.errors?.['required']){
        <small class="error-text">Please enter a valid name</small>
        }
      </div>
      } @if(securityStep === 2){
      <div class="form-group">
        <label for="dpSerialNo">Enter your Ritwik's Name * (include middle name & spaces exactly as on your Arghya Praswasti)</label>
        <input
          id="dpSerialNo"
          type="text"
          formControlName="ritwikName"
          placeholder="Enter ritwik's name"
        />
        @if(securityForm.get('ritwikName')?.touched && securityForm.get('ritwikName')?.invalid){
        <small class="error-text">Ritwik's Name is required</small>
        }
      </div>
      } @if(securityStep === 3){
      <div class="form-group">
        <label for="arghyaSerialNo"
          >Enter any Arghya Praswasti Serial/Voucher Number in which you deposited Ishtabhriti</label
        >
        <input
          id="arghyaSerialNo"
          type="text"
          formControlName="arghyaSerialNo"
          placeholder="Enter Arghya Praswasti Serial No"
          (input)="onSerialChange('arghyaSerialNo')"
          (keypress)="restrictAPSerialInput($event)"
          maxlength="17"
        />
      </div>
      <span class="or-divider">OR</span>
      <div class="form-group">
        <label for="dpSerialNo">Enter your Dikshya Patra Serial Number?</label>
        <input
          id="dpSerialNo"
          type="text"
          formControlName="dpSerialNo"
          placeholder="Enter Dp Serial No"
          (input)="onSerialChange('dpSerialNo')"
          (keypress)="restrictFCInput($event)"
        />
      </div>
      } @if(securityStep === 4){
      <div class="otp-box">
        <div class="form-group">
          <label for="otp">Enter OTP</label>
          <input
            type="text"
            id="otp"
            [(ngModel)]="this.otp"
            maxlength="6"
            placeholder="Enter OTP"
            (ngModelChange)="validateOtp()"
            (keypress)="allowOnlyDigits($event)"
            [ngModelOptions]="{standalone: true}"
          />
          @if(otpError){
          <small class="error-text">{{ otpError }}</small>
          }
        </div>

        <button class="verify-btn" (click)="verifyOtp()">
          @if(isLoading){
          <span class="spinner" role="status" aria-label="Loading"></span>
          } @else{ Verify OTP }
        </button>
        <div class="resend-text mt-3">
          @if(countdown !==0){
          <ng-container> Resend OTP in {{ countdown }}s </ng-container>
          } @else {
          <span class="resend-link" (click)="resendOTP()">Resend OTP</span>
          }
        </div>
      </div>
      }
      <!-- @if(securityStep === 4){
    <div class="form-group">
      <label for="identityNo">Q. What is your Identity Number ? *</label>
      <input
        id="identityNo"
        type="text"
        formControlName="identityNo"
        placeholder="Enter Identity Number"
      />
      @if (securityForm.get('identityNo')?.touched && securityForm.get('identityNo')?.invalid) {
      <div class="error-text">Identity Number is required</div>
      }
    </div>
    } -->
      @if(securityStep<4){
      <div class="securityform-footer">
        <!-- <button type="button" class="securityform-btn secondary" (click)="prevSecurityStep()"
          [disabled]="securityStep === 1">
          Back
        </button> -->

        <button
          type="submit"
          class="securityform-btn primary"
          (click)="nextSecurityStep()"
          [disabled]="isNextDisabled()"
        >
          @if(isLoading){
          <span class="spinner" role="status" aria-label="Loading"></span>
          }@else{ Next }
        </button>
      </div>
      }
      <div class="securityform-cancel-container">
        <button type="button" class="securityform-cancel-btn" (click)="cancelSecurityFlow()">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
